export default __webpack_public_path__ + "static/India New-1eebd4c2901e08985d8516332abb6a11.jpg";